import React, { type FC } from 'react';

import { SuggestionAttribute, type SuggestionSource } from '@zen/graphql/types.generated';

import { extractProposedText } from './helpers';
import { SuggestionPill } from './SuggestionPill/SuggestionPill';
import { SuggestionPopover } from './SuggestionPopover/SuggestionPopover';
import { SuggestionText } from './SuggestionText/SuggestionText';

interface SuggestionProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string) => void;
  proposedValue: string;
  sources: SuggestionSource[];
  targetAttribute: SuggestionAttribute;
  variant: 'pill' | 'popover' | 'text';
}

const Suggestion: FC<SuggestionProps> = ({ proposedValue, targetAttribute, id, onAccept, onReject, sources, variant }) => {
  const proposedValueText = extractProposedText(proposedValue, targetAttribute);

  if (variant === 'pill')
    return <SuggestionPill id={id} onAccept={onAccept} onReject={onReject} proposedValueText={proposedValueText} />;

  if (variant === 'popover')
    return (
      <SuggestionPopover
        id={id}
        onAccept={onAccept}
        onReject={onReject}
        proposedValueText={proposedValueText}
        sources={sources}
      />
    );

  if (variant === 'text')
    return <SuggestionText id={id} onAccept={onAccept} onReject={onReject} proposedValueText={proposedValueText} />;
};

export default Suggestion;
